export interface EquipmentCategory {
    equcate_id?: number
    equcate_name?: string
}

export interface EquipmentCategoryProps {
    equcate_id?: number | string
    equcate_name?: string
}

export const ObjectToEquipmentCategory = (obj: EquipmentCategoryProps): EquipmentCategory => {
    return {
        equcate_id: typeof obj.equcate_id == 'string' ? parseInt(obj.equcate_id) : obj.equcate_id,
        equcate_name: obj.equcate_name
    }
}